import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmAuthSsoOnlyAvailableError } from '@/core/error/transport/auth/TmAuthSsoOnlyAvailableError'

export const ssoLoginValidOnlyErrorRule: CustomErrorRule = {
  klass: TmAuthSsoOnlyAvailableError,
  subCodes: ['auth.only_using_sso'],
}
